module.exports = ".wrapper {\n  position: relative;\n  z-index: 1;\n  box-sizing: border-box;\n  -webkit-overflow-scrolling: touch;\n  background: #ff0000;\n  background: radial-gradient(circle, #ff0000 0%, #8C0014 70%);\n  padding: 1rem;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  overflow: hidden;\n  width: 100%;\n  height: calc(100vh - 60px); }\n\n.main {\n  z-index: 1;\n  display: block;\n  height: 100%;\n  overflow: auto;\n  width: 100%;\n  overflow-x: hidden; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/layout.component.scss
// module id = 905
// module chunks = 10